import { DatePipe, isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { MessageService } from 'primeng/api';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {
  HappyPayActivities,
  HappyPayBalance,
} from '../interfaces/happy-pay.interface';
import { User } from '../interfaces/user.interface';
import { UserService } from './user.service';

const apiUrl = environment.apiUrl + 'user/happy_pay';

@Injectable({
  providedIn: 'root',
})
export class HappyPayService {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private http: HttpClient,
    private datePipe: DatePipe,
    private messageService: MessageService,
    private userService: UserService
  ) {}

  getBalance() {
    return this.http.get(apiUrl).pipe(
      map((res: any) => {
        let data = res.data;
        data.current_balance = Number(data.current_balance);
        if (isPlatformBrowser(this.platformId)) {
          let user: User = this.userService.currentUserValue.value;
          user.happy_pay.current_balance = data.current_balance;
          user.happy_pay.account_no = data.account_no;
          this.userService.changeCurrentUserData(user);
        }
        return data;
      })
    );
  }

  getBalanceHistory(itemPerPage: number, currentPage: number = 1) {
    const body = {
      item_per_page: itemPerPage,
      current_page: currentPage,
      sorts: [{ field: 'created_at', direction: 'DESC' }],
    };
    return this.http
      .post(apiUrl + '/balance_history', body)
      .pipe(
        map((res: any) => {
          let history: HappyPayBalance[] = res.data;
          history.forEach((his) => {
            if (his.created_at)
              his.formatted_created_at =
                this.datePipe.transform(
                  new Date(his.created_at),
                  'dd MMM yyyy, HH:mm'
                ) || '';
          });
          return history;
        })
      )
      .pipe(
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  getActivities(
    itemPerPage: number,
    currentPage: number = 1,
    dateFilter: any = null
  ) {
    return this.http
      .post(apiUrl + '/activities', {
        item_per_page: itemPerPage,
        current_page: currentPage,
        start_date: dateFilter ? dateFilter.start : null,
        end_date: dateFilter ? dateFilter.end : null,
      })
      .pipe(
        map((res: any) => {
          return {
            totalItems: res.data['total_items'],
            happyPayActivities: res.data[
              'happy_pay_account'
            ] as HappyPayActivities[],
          };
        })
      );
  }

  private handleSuccess(message: any) {
    this.messageService.clear();
    this.messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: message,
    });
  }
}
